import Swiper, {Autoplay} from 'swiper';

Swiper.use([Autoplay]);

let className = '.front-page-projects-content-slider .swiper-container';

export default () => {
    let container = document.querySelector(className);
    if (container) {
        let mobileProjectsSlider = slider(container);

        window.addEventListener('resize', () => {
            slidesHeight(className);
        });
    }
}

let slider = (container) => {
    let swiper = new Swiper(container, {
        slidesPerView: 2,
        spaceBetween: 20,
        loop: true,
        calculateHeight: true,
        freeMode: true,
        breakpoints: {
            376: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            }
        }
    });

    swiper.on('update', function () {
        slidesHeight(className);
    });

    swiper.update();

    return swiper;
}

let slidesHeight = (className) => {
    let container = document.querySelector(className);
    let slides = container.querySelectorAll('.swiper-slide');

    slides.forEach((slide) => {
        slide.style.height = slide.offsetWidth + 'px';
    });
}
